import { createSelector } from '@reduxjs/toolkit'
import { accountDetailDataSelector } from './selectors'

export const individualPortfolioSelector = createSelector(
  [
    accountDetailDataSelector.isInitialLoadingSelector,
    accountDetailDataSelector.payloadSelector,
    accountDetailDataSelector.rootSelector,
    accountDetailDataSelector.hasErrorSelector,
  ],
  (isLoading, accountDetail, { meta, error }) => ({
    isLoading,
    accountDetail,
    meta,
    hasError: error,
  }),
)
